import {DynamicProductGrid} from "../../organisms/widget--product-grid";

export function ParagraphProductGrid ({paragraph, ...props}) {
  // Filter out any references that no longer exist.
  const products = paragraph?.field_product_grid_products?.length
    ? paragraph.field_product_grid_products.filter(item => item?.title !== undefined) : [];
  if (!products.length) return <></>

  return <DynamicProductGrid nodes={paragraph.field_product_grid_products}/>;
}